import type { CourtMatch, ParsedTicketData } from '../components/UploadTicket/UploadTicket';

/**
 * The New Ticket form's fields from what /ticket-upload read off the citation.
 *
 * The staff wizard used to pass on seven of them and drop the rest: the respond-by date (the one date
 * the form requires), the issuing agency, the agency case number, the plate and the court match were
 * all read by the server and thrown away before the form saw them (Oct 2026). This passes on
 * everything the server sends.
 */
export function parsedTicketFromUploadResponse(result: Record<string, unknown>): ParsedTicketData {
  const text = (key: string): string | undefined => {
    const value = result[key];
    return typeof value === 'string' && value.trim() !== '' ? value : undefined;
  };
  return {
    Ticket_Number: text('Ticket_Number'),
    Ticket_Citation: text('Ticket_Citation'),
    Ticket_Address: text('Ticket_Address'),
    Ticket_City: text('Ticket_City'),
    Ticket_County: text('Ticket_County'),
    Ticket_CourtDate: text('Ticket_CourtDate'),
    Ticket_CourtName: text('Ticket_CourtName'),
    Ticket_RespondBy: text('Ticket_RespondBy'),
    Ticket_ArrestingAgency: text('Ticket_ArrestingAgency'),
    Ticket_AgencyCaseNumber: text('Ticket_AgencyCaseNumber'),
    Ticket_LicensePlate: text('Ticket_LicensePlate'),
    Ticket_LicenseType: text('Ticket_LicenseType'),
    courtMatch: (result.courtMatch as CourtMatch | null | undefined) ?? null,
  };
}
